const formatNumber = (value: number, locale = 'en-US') => {
    if (value === null || value === undefined) {
      return '-'; // Or any other placeholder for null/undefined values
    }
    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      minimumFractionDigits: 2, // Ensure at least two decimal places
      maximumFractionDigits: 2, // Ensure no more than two decimal places
    }).format(value);
};

function formatBytes(bytes: any, decimals = 2) {
        if (bytes === 0){
            return "0 Bytes";
        }
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }


export { formatNumber, formatBytes };